import { render, staticRenderFns } from "./NsProductDetailBase.vue?vue&type=template&id=30c40d76&scoped=true&"
import script from "./NsProductDetailBase.vue?vue&type=script&lang=js&"
export * from "./NsProductDetailBase.vue?vue&type=script&lang=js&"
import style0 from "./NsProductDetailBase.vue?vue&type=style&index=0&id=30c40d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c40d76",
  null
  
)

export default component.exports